/* Calibre — pildora de icono en las fichas de categoria de la home.

   RETIRADA en agosto 2026. La clienta decidio que las laminas de la home van
   con foto y que los iconos van en el cajon movil, asi que la pildora quedaba
   como un adorno encima de la fotografia. Los iconos de linea viven ahora en
   snippets/calibre-icono.liquid, que alimenta tanto el modo icono de la
   seccion como las fichas del cajon (ver calibre-extra.js).

   Se deja constancia aca en vez de borrar el archivo entero porque lo que
   sigue, la cabecera del filtro y el boton de "Mostrar mas", si esta en uso. */

/* Calibre — cabecera del filtro de colecciones.
   La referencia lleva un titulo "FILTROS" con embudo arriba de la barra
   lateral. Horizon pone ese titulo en el riel de arriba, junto al orden, asi
   que aca se agrega uno propio dentro de la barra, que es donde la clienta
   espera verlo. No se toca el bloque filters del tema. */
(function () {
  function poner() {
    var lateral = document.querySelector('.facets--vertical .facets__form');
    if (!lateral || lateral.querySelector('.cal-filtros-titulo')) return;
    var lista = lateral.querySelector('.facets__filters-wrapper');
    if (!lista) return;

    var t = document.createElement('p');
    t.className = 'cal-filtros-titulo';
    t.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" ' +
      'stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
      '<path d="M3.5 5.5h17l-6.5 7.6v5.6l-4 2.3v-7.9z"/></svg><span>Filtros</span>';
    lista.parentNode.insertBefore(t, lista);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', poner, { once: true });
  } else {
    poner();
  }
  // El bloque se vuelve a pintar al aplicar un filtro: se repone el titulo.
  document.addEventListener('click', function () { setTimeout(poner, 400); });
})();

/* Calibre — "Mostrar más" al final de la coleccion.
   Agosto 2026, pedido de la clienta.

   La referencia (blush-bar.cl/maquillaje) NO usa carga automatica: pone un
   boton "Mostrar más" y el resto de la pagina queda quieto hasta que lo
   pulsas. La nuestra cargaba sola al llegar abajo, que es lo que trae Horizon.

   COMO SE APAGA LA CARGA AUTOMATICA: el tema dispara la pagina siguiente con
   un IntersectionObserver sobre un centinela, [ref="viewMoreNext"]. Ese
   centinela se esconde por CSS, y un elemento en display:none nunca
   interseca, asi que el observador del tema deja de disparar solo. No hay que
   tocar paginated-list.js.

   La pagina siguiente se pide igual que la pide el tema: ?page=N&section_id=,
   que devuelve el HTML de la seccion. De ahi se sacan las tarjetas y se
   agregan. El fundido de entrada ya lo aplica calibre.js a lo que aparece en
   la grilla, asi que aca no se repite. */
(function () {
  var lista = document.querySelector('results-list[section-id]');
  if (!lista) return;

  var seccion = lista.getAttribute('section-id');
  var boton, pie, cargando = false;

  function grid() { return lista.querySelector('[ref="grid"]'); }

  function estado() {
    var g = grid();
    if (!g) return null;
    var ultima = parseInt(g.dataset.lastPage, 10);
    var tarjetas = g.querySelectorAll(':scope > [ref="cards[]"]');
    if (!ultima || !tarjetas.length) return null;
    var actual = parseInt(tarjetas[tarjetas.length - 1].dataset.page, 10) || 1;
    return { ultima: ultima, actual: actual, vistos: tarjetas.length };
  }

  function total() {
    var n = document.querySelector('.products-count-wrapper span');
    if (!n) return null;
    var m = (n.textContent || '').match(/(\d[\d.,]*)/);
    return m ? m[1] : null;
  }

  function pintar() {
    var e = estado();
    if (!e) return;
    if (e.actual >= e.ultima) { quitar(); return; }

    if (!boton) {
      var caja = document.createElement('div');
      caja.className = 'cal-vermas';
      boton = document.createElement('button');
      boton.type = 'button';
      boton.className = 'cal-vermas__boton';
      boton.addEventListener('click', traer);
      pie = document.createElement('p');
      pie.className = 'cal-vermas__pie';
      caja.appendChild(boton);
      caja.appendChild(pie);
      var g = grid();
      g.parentNode.insertBefore(caja, g.nextSibling);
    }
    boton.textContent = cargando ? 'Cargando…' : 'Mostrar más';
    boton.disabled = cargando;
    var t = total();
    pie.textContent = t ? e.vistos + ' de ' + t + ' productos' : '';
  }

  function quitar() {
    if (!boton) return;
    var caja = boton.parentNode;
    if (caja && caja.parentNode) caja.parentNode.removeChild(caja);
    boton = null; pie = null;
  }

  function traer() {
    if (cargando) return;
    var e = estado();
    if (!e || e.actual >= e.ultima) return;

    cargando = true;
    pintar();

    var u = new URL(window.location.href);
    u.searchParams.set('page', String(e.actual + 1));
    u.searchParams.set('section_id', seccion);

    fetch(u.toString())
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var otra = doc.querySelector('[ref="grid"]');
        var nuevas = otra ? otra.querySelectorAll(':scope > [ref="cards[]"]') : [];
        var g = grid();
        if (!g || !nuevas.length) throw new Error('sin tarjetas');
        for (var i = 0; i < nuevas.length; i++) g.appendChild(nuevas[i]);

        // La direccion acompaña a lo que se ve, como hace el tema: si la
        // clienta recarga o comparte, cae en la misma altura del catalogo.
        var visible = new URL(window.location.href);
        visible.searchParams.set('page', String(e.actual + 1));
        history.replaceState('', '', visible.toString());

        cargando = false;
        pintar();
      })
      .catch(function () {
        cargando = false;
        pintar();
        if (boton) boton.textContent = 'Reintentar';
      });
  }

  pintar();
  // Al filtrar u ordenar, el tema vuelve a pintar la grilla entera: se
  // recalcula el boton en vez de dejarlo con el conteo viejo.
  new MutationObserver(function () {
    if (!cargando) setTimeout(pintar, 200);
  }).observe(lista, { childList: true, subtree: true });
})();
